import {HomonymService} from './homonym.service';

export const HomonymInjectables: Array<any> = [
  {
    provide: HomonymService,
    useClass: HomonymService,
  },
];
